import * as React from "react";
import { H3, Text } from "@grandvisionhq/iris-ui";
/* empty css                                         */
const ConfiguratorStepTitleAndDescription = ({
  title,
  description,
  descriptionSuffix,
  textAlignment = "center"
}) => {
  const hasDescriptionOrSuffix = description || descriptionSuffix;
  const hasDescriptionAndSuffix = description && descriptionSuffix;
  return /* @__PURE__ */ React.createElement("div", { className: "configurator-step-headings" }, /* @__PURE__ */ React.createElement(
    H3,
    {
      variant: "heading-medium",
      align: textAlignment,
      className: "configurator-step-headings__title"
    },
    title
  ), hasDescriptionOrSuffix && /* @__PURE__ */ React.createElement(
    Text,
    {
      className: "configurator-step-headings__description",
      variant: "body",
      align: textAlignment
    },
    description,
    hasDescriptionAndSuffix && " ",
    descriptionSuffix
  ));
};
export {
  ConfiguratorStepTitleAndDescription as default
};
//# sourceMappingURL=ConfiguratorStepTitleAndDescription.js.map
